import {
  CREATE_PROCESS_ORDERS_REQUEST,
  CREATE_PROCESS_ORDERS_SUCCESS,
  CREATE_PROCESS_ORDERS_ERROR,
  RESET_CREATE_PROCESS_ORDERS,
} from "redux/actions/action-type";

const initialState = {
  createProcessOrderResponse: [],
  isCreateProcessOrderLoading: false,
  isCreateProcessOrderSuccess: false,
  isCreateProcessOrderError: false,
  errorMessage : {}
};

const createProcessOrderReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case CREATE_PROCESS_ORDERS_REQUEST:
      return {
        ...state,
        isCreateProcessOrderLoading: true,
        isCreateProcessOrderSuccess: false,
        isCreateProcessOrderError: false,
      };
    case CREATE_PROCESS_ORDERS_SUCCESS:
      return {
        createProcessOrderResponse: payload,
        isCreateProcessOrderLoading: false,
        isCreateProcessOrderSuccess: true,
        isCreateProcessOrderError: false,
      };
    case CREATE_PROCESS_ORDERS_ERROR:
      return {
        ...state,
        isCreateProcessOrderLoading: false,
        isCreateProcessOrderSuccess: false,
        isCreateProcessOrderError: true,
        errorMessage:payload
      };
    case RESET_CREATE_PROCESS_ORDERS:
      return initialState;
    default:
      return state;
  }
};

export default createProcessOrderReducer;
